module.exports = __webpack_public_path__ + "media/images/bg/shapes/cloud-lightblue-8ac33276d6679b4354996e3f198934b9.svg";